import { env } from '@/env';

export const initAnalytics = () => {
  // Google Analytics is auto-loaded via <Script> in layout.tsx
  // Initialize Meta Pixel
  if (typeof window !== 'undefined' && !window.fbq) {
    import('react-facebook-pixel').then((ReactPixel) => {
      ReactPixel.default.init(env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID, undefined, {
        debug: false,
        autoConfig: true,
      });
      ReactPixel.default.pageView();
    });
  }
};

export const trackPageView = (url: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  // GA
  if (window.gtag && env.NEXT_PUBLIC_GA_ID) {
    window.gtag('config', env.NEXT_PUBLIC_GA_ID, { page_path: url });
  }

  // Meta
  import('react-facebook-pixel').then((ReactPixel) => {
    ReactPixel.default.pageView();
  });
};

export const trackEvent = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label: string;
  value: number;
}) => {
  if (typeof window === 'undefined') {
    return;
  }

  // Google Analytics
  if (window.gtag && env.NEXT_PUBLIC_GA_ID) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }

  // Meta
  import('react-facebook-pixel').then((ReactPixel) => {
    ReactPixel.default.track(action, { label, value, category });
  });
};

// this code should be in global.d.ts
// export {};

// declare global {
//   interface Window {
//     // biome-ignore lint/suspicious/noExplicitAny: -
//     gtag?: (...args: any[]) => void;
//     // biome-ignore lint/suspicious/noExplicitAny: -
//     fbq?: (...args: any[]) => void;
//   }
// }
